(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  let frame;

  const update = () => {
    frame = undefined;
    const button = document.querySelector('.product__info-container .product-form__submit');
    const form = button && button.closest('product-form');

    if (!mobile.matches || !button || !form) {
      document.body.classList.remove('tw-mobile-purchase-active');
      document.querySelectorAll('.tw-mobile-sticky-active').forEach((element) => {
        element.classList.remove('tw-mobile-sticky-active');
      });
      return;
    }

    const formBounds = form.getBoundingClientRect();
    const formIsVisible = formBounds.top < window.innerHeight - 24 && formBounds.bottom > 96;
    const shopperIsEngaged = window.scrollY > 240;
    const isActive = shopperIsEngaged && !formIsVisible;

    button.classList.toggle('tw-mobile-sticky-active', isActive);
    document.body.classList.toggle('tw-mobile-purchase-active', isActive);
  };

  const requestUpdate = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(update);
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  mobile.addEventListener('change', requestUpdate);
  document.addEventListener('shopify:section:load', requestUpdate);

  const productInfo = document.querySelector('product-info');
  if (productInfo) {
    new MutationObserver(requestUpdate).observe(productInfo, { childList: true, subtree: true });
  }

  requestUpdate();
})();
